import { EDictionaryTypes } from 'models/dictionary';

const dictionaryTypeToTranslationKey: Record<string, string> = {
  [EDictionaryTypes.Country]: 'dictionary.name.country',
  [EDictionaryTypes.CountryAll]: 'dictionary.name.country.all',
  [EDictionaryTypes.Caliber]: 'dictionary.name.caliber',
  [EDictionaryTypes.Manufacturer]: 'dictionary.name.manufacturer',
  [EDictionaryTypes.ManufacturerCountry]: 'dictionary.name.manufacturer.country',
  [EDictionaryTypes.FirearmAction]: 'dictionary.name.firearm.action',
  [EDictionaryTypes.FirearmType]: 'dictionary.name.firearm.type',
  [EDictionaryTypes.Region]: 'dictionary.name.region',
  [EDictionaryTypes.Gender]: 'dictionary.name.gender',
  [EDictionaryTypes.OrganisationCivilianType]: 'dictionary.name.organization.civilianType',
  [EDictionaryTypes.OrganisationStateType]: 'dictionary.name.organization.stateType',
  [EDictionaryTypes.OrganisationMilitaryType]: 'dictionary.name.organization.militaryType',
  [EDictionaryTypes.OrganisationPoliceType]: 'dictionary.name.organization.policeType',
  [EDictionaryTypes.OrganisationCategory]: 'dictionary.name.organisation.category',
  [EDictionaryTypes.LegalVisibility]: 'dictionary.name.legal.visibility',
  [EDictionaryTypes.legalEntityPrefix]: 'dictionary.name.prefix.type',
  [EDictionaryTypes.civilianPrefix]: 'dictionary.name.civilian.prefix',
  [EDictionaryTypes.militaryPrefix]: 'dictionary.name.military.prefix',
  [EDictionaryTypes.policePrefix]: 'dictionary.name.police.prefix',
  [EDictionaryTypes.PhoneCode]: 'dictionary.name.phone.code.type',
  [EDictionaryTypes.Legality]: 'dictionary.name.legality',
  [EDictionaryTypes.Make]: 'dictionary.name.make',
  [EDictionaryTypes.Model]: 'dictionary.name.model',
  [EDictionaryTypes.State]: 'dictionary.name.state',
  [EDictionaryTypes.BarrelType]: 'dictionary.name.barrel.type',
  [EDictionaryTypes.Level]: 'dictionary.name.level',
  [EDictionaryTypes.AddressType]: 'dictionary.name.address.type',
  [EDictionaryTypes.TransactionType]: 'dictionary.name.transaction.type',
  [EDictionaryTypes.LegalClassification]: 'dictionary.name.legal.classification',
  [EDictionaryTypes.Activity]: 'dictionary.name.activity',
  [EDictionaryTypes.nationality]: 'dictionary.name.nationality.type',
  [EDictionaryTypes.legalType]: 'dictionary.name.legal.type',
  [EDictionaryTypes.currency]: 'dictionary.name.currency',
  [EDictionaryTypes.measurementUnit]: 'dictionary.name.measurement.unit',
  [EDictionaryTypes.MaritalStatus]: 'dictionary.name.marital.status',
  [EDictionaryTypes.IdentificationDocumentType]:
    'dictionary.name.identification.document.type',
  [EDictionaryTypes.attachmentDocumentTypeData]: 'dictionary.name.attachment.document.type',
  [EDictionaryTypes.AuditLogModule]: 'dictionary.name.module',
  [EDictionaryTypes.AuditLogEventType]: 'dictionary.name.auditlog.event_type',
  [EDictionaryTypes.AuditLogEventName]: 'dictionary.name.auditlog.event_name',
  [EDictionaryTypes.ApiKeyType]: 'dictionary.name.apikey.type',
  [EDictionaryTypes.ArtAncillaryOptions]: 'dictionary.name.art.ancillary.type',
  [EDictionaryTypes.ArtComposition]: 'dictionary.name.art.composition',
  [EDictionaryTypes.ArtAccessoryType]: 'dictionary.name.art.accessory.type',
  [EDictionaryTypes.ArtAccessoryCalibre]: 'dictionary.name.art.accessory.calibre',
  [EDictionaryTypes.ArtAccessoryHostType]: 'dictionary.name.art.accessory.host_type',
  [EDictionaryTypes.ArtAccessoryLightColour]: 'dictionary.name.art.accessory.light_colour',
  [EDictionaryTypes.ArtAccessoryMagnification]: 'dictionary.name.art.accessory.magnification',
  [EDictionaryTypes.ArtAccessoryReticle]: 'dictionary.name.art.accessory.reticle',
  [EDictionaryTypes.ArtAccessoryUtility]: 'dictionary.name.art.accessory.utility',
  [EDictionaryTypes.ArtAccessoryProofHouse]: 'dictionary.name.art.accessory.proof_house',
  [EDictionaryTypes.ArtAccessoryManufacturerMagazine]:
    'dictionary.name.art.accessory.manufacturer.magazine',
  [EDictionaryTypes.ArtAccessoryManufacturerOpticalSight]:
    'dictionary.name.art.accessory.manufacturer.optical_sight',
  [EDictionaryTypes.ArtAccessoryManufacturerSuppressor]:
    'dictionary.name.art.accessory.manufacturer.suppressor',
  [EDictionaryTypes.ArtAccessoryManufacturerFlashEliminator]:
    'dictionary.name.art.accessory.manufacturer.flash_eliminator',
  [EDictionaryTypes.ArtAccessoryManufacturerLaserLightModule]:
    'dictionary.name.art.accessory.manufacturer.laser_light_module',
  [EDictionaryTypes.ArtAmmunitionType]: 'dictionary.name.art.ammunition.type',
  [EDictionaryTypes.ArtAmmunitionManufacturer]: 'dictionary.name.art.ammunition.manufacturer',
  [EDictionaryTypes.ArtAmmunitionFactory]: 'dictionary.name.art.ammunition.factory',
  [EDictionaryTypes.ArtAmmunitionCalibreGauge]: 'dictionary.name.art.ammunition.calibre_gauge',
  [EDictionaryTypes.ArtAmmunitionCartridgeComposition]:
    'dictionary.name.art.ammunition.cartridge_composition',
  [EDictionaryTypes.ArtAmmunitionColourOfPrimerSealant]:
    'dictionary.name.art.ammunition.colour_of_primer_sealant',
  [EDictionaryTypes.ArtAmmunitionProjectileShape]:
    'dictionary.name.art.ammunition.projectile_shape',
  [EDictionaryTypes.ArtAmmunitionFunctionalType]:
    'dictionary.name.art.ammunition.functional_type',
  [EDictionaryTypes.ArtAmmunitionShotSize]: 'dictionary.name.art.ammunition.shot_size',
  [EDictionaryTypes.ArtAmmunitionMunitionType]: 'dictionary.name.art.ammunition.munition_type',
  [EDictionaryTypes.ArtAmmunitionMunitionVelocity]:
    'dictionary.name.art.ammunition.munition_velocity',
  [EDictionaryTypes.ArtComponentType]: 'dictionary.name.art.component.type',
  [EDictionaryTypes.ArtComponentManufacturer]: 'dictionary.name.art.component.manufacturer',
  [EDictionaryTypes.ArtComponentCalibre]: 'dictionary.name.art.component.calibre',
  [EDictionaryTypes.ArtComponentCapacity]: 'dictionary.name.art.component.capacity',
  [EDictionaryTypes.ArtComponentProofHouse]: 'dictionary.name.art.component.proof_house',
  [EDictionaryTypes.weaponLicenceCategory]: 'dictionary.name.weapon.licence.category',
  [EDictionaryTypes.weaponLicenceCondition]: 'dictionary.name.weapon.licence.condition',
  [EDictionaryTypes.weaponLicenceCompetency]: 'dictionary.name.weapon.licence.competency',
  [EDictionaryTypes.weaponLicenceGoodReason]: 'dictionary.name.weapon.licence.good.reason',
  [EDictionaryTypes.weaponLicencingAuthority]: 'dictionary.name.weapon.licencing.authority',
  [EDictionaryTypes.weaponLicenceLimit]: 'dictionary.name.weapon.licence.limit',
  [EDictionaryTypes.applicationProcessTypes]: 'dictionary.name.weapon.licence.process.type',
  [EDictionaryTypes.weaponLicenceStatus]: 'dictionary.name.weapon.licence.status',
  [EDictionaryTypes.weaponLicencePaymentStatus]:
    'dictionary.name.weapon.licence.payment.status',
  [EDictionaryTypes.weaponLicenceHistoryAction]:
    'dictionary.name.weapon.licence.history.action',
  [EDictionaryTypes.legalStatus]: 'dictionary.name.legal.status',
  [EDictionaryTypes.legalIndividualDeactivationReason]:
    'dictionary.name.legal.individual.deactivation.reason',
  [EDictionaryTypes.legalOrganisationDeactivationReason]:
    'dictionary.name.legal.organisation.deactivation.reason',
  [EDictionaryTypes.intelligenceReportSourceSystem]:
    'dictionary.name.intelligence.report.source.system',
};

export const mapDictionaryTypeToTranslationKey = (type: string): string =>
  dictionaryTypeToTranslationKey[type] ?? type;
